/** Canonical quantity family and its retired level-row aliases, consumed on hit by K4. */
export const MIRROR_IMAGE_STATUS_IDS: ReadonlySet<string> = new Set([
  'CDC5CFDA-B09C-4A68-820D-6C74D90BD595',
  'D9B64F38-A817-47B8-AB07-60D59F3D893C', 'AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139', '479A4B5C-43F3-3559-979B-5BDA8A379F07',
]);
